import { graphql } from "~/gql";

export const UPDATE_LIBRARY_ASSUMPTIONS = graphql(/* GraphQL */ `
  mutation UpdateLibraryAssumptions($data: [LibraryAssumptionUpdate!]!) {
    updateLibraryAssumptions(data: $data) {
      updatedAssumptions {
        id
        text
        mandatory
        default
        organisationalUnits {
          name
          id
        }
        createdAt
      }
      matterIds
    }
  }
`);
